import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  constructor(private http: HttpClient) {

  }

  getCampaignLink(cId: number, rId: number): Observable<{ id: string }> {
    return this.http.get<{ id: string }>(
      `${environment.apiUrl}/Campaign/UserClickedCampaign/${cId}/${rId}`);
  }
}
